import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { useAtom, useAtomValue } from 'jotai'
import { countryState, languageState } from '@repo/unicity'

const Footer = () => {
    const country = useAtomValue(countryState)
    const [language, setLanguage] = useAtom(languageState)
    return (
        <Stack
            sx={{
                height: '64px',
                backgroundColor: 'rgba(3, 39, 76, 1)',
                marginTop: 'auto',
                padding: {
                    xs: '0px 8px',
                    sm: '0px 30px'
                },
                alignItems: 'center',
                justifyContent: {
                    xs: 'center',
                    sm: 'space-between'
                },
                flexDirection: {
                    xs: 'column',
                    sm: 'row'
                },
                gap: {
                    xs: '0px',
                    sm: '8px'
                }
            }}
            component={'footer'}>
            <Stack flexDirection={'row'} gap={'4px'} alignItems={'center'}>
                <Box>
                    <Typography variant="footer" color="white" fontSize={'12px'}>
                        © All Rights Reserved.
                    </Typography>
                </Box>
                <Box
                    sx={{
                        '@media (min-width: 768px)': {
                            display: 'none'
                        }
                    }}>
                    <Typography
                        variant="footer"
                        color="white"
                        sx={{
                            fontSize: '12px'
                        }}>
                        Protected by reCAPTCHA
                    </Typography>
                </Box>
            </Stack>
            <Stack direction={'row'} gap={'16px'}>
                <Box
                    sx={{
                        '@media (max-width: 767px)': {
                            display: 'none'
                        }
                    }}
                    display={'flex'}
                    alignItems={'center'}>
                    <Typography variant="footer" color="white" fontSize={'12px'}>
                        Protected by reCAPTCHA
                    </Typography>
                </Box>
                <Box
                    sx={{ cursor: 'pointer', borderBottom: '1px solid white', boxSizing: 'border-box' }}
                    onClick={() => window.open('https://www.unicity.com/usa/en/privacy-policy', '_blank')}
                    display={'flex'}
                    alignItems={'center'}>
                    <Typography
                        variant="footer"
                        color="white"
                        sx={{
                            fontSize: '12px'
                        }}>
                        Privacy Policy
                    </Typography>
                </Box>
                <Box
                    sx={{ cursor: 'pointer', borderBottom: '1px solid white', boxSizing: 'border-box' }}
                    onClick={() => window.open('https://www.unicity.com/usa/en/terms-of-use', '_blank')}
                    display={'flex'}
                    alignItems={'center'}>
                    <Typography
                        variant="footer"
                        color="white"
                        sx={{
                            fontSize: '12px'
                        }}>
                        Terms of Service
                    </Typography>
                </Box>
                <Stack
                    direction={'row'}
                    gap={{
                        xs: '8px',
                        sm: '10px'
                    }}
                    alignItems={'center'}
                    justifyContent={'center'}
                    pt="2px">
                    {country.config.languageSettings.items.map((item, index) => {
                        return (
                            <Box
                                key={item.code}
                                sx={{ whiteSpace: 'nowrap', display: 'flex', alignItems: 'center', cursor: 'pointer', justifyContent: 'center' }}
                                onClick={() => setLanguage(item.code)}
                                display={'flex'}
                                alignItems={'center'}>
                                <Typography
                                    variant="muted"
                                    sx={{
                                        fontSize: '12px'
                                    }}
                                    fontWeight={language === item.code ? 700 : 400}
                                    color="white">
                                    {item.name}
                                </Typography>
                                {index !== country.config.languageSettings.items.length - 1 && (
                                    <Typography
                                        variant="muted"
                                        sx={{
                                            paddingLeft: {
                                                xs: '8px',
                                                sm: '10px'
                                            }
                                        }}
                                        color="white">
                                        |
                                    </Typography>
                                )}
                            </Box>
                        )
                    })}
                </Stack>
            </Stack>
        </Stack>
    )
}

export default Footer
